import type { ProviderSource, TemplateInfo, TemplateType } from '~/types/template';

import { parseProviderSources } from '~/constants/providerSource';
import { PROVIDER_CONFIG } from '~/constants/providerConfig';
import { TEMPLATE_IMAGE } from '~/constants/template';
import type { IThemePage } from '~/stores/themePage';

export const getDefaultThumbnail = (providerSource?: TemplateInfo['providerSource']) => {
  if (!providerSource) return TEMPLATE_IMAGE.DEFAULT;
  return PROVIDER_CONFIG[providerSource]?.thumbnail ?? TEMPLATE_IMAGE.DEFAULT;
};

export const getSuffixTemplateV7By = (id: string, pageType: TemplateType): string => {
  return `templates/${pageType}.gp-template-${id}.json`;
};
export const getTemplateSuffixBySuffix = (pageType: TemplateType, suffix: string): string => {
  if (pageType === suffix || !suffix) {
    return `templates/${pageType}.json`;
  }
  return `templates/${pageType}.${suffix}.json`;
};
export const getTemplateSuffixByThemePage = (themePage?: IThemePage): string => {
  return `templates/${themePage?.type}.gp-template-${themePage?.id}.json`;
};

export const getProviderConfig = (providerSource?: ProviderSource) => {
  return providerSource ? PROVIDER_CONFIG[providerSource] : undefined;
};

export const getProviderSourceParser = (providerSource?: ProviderSource) => {
  if (!providerSource) return;

  const providerSourceInfo = parseProviderSources.find(
    (source) => source.providerSource === providerSource,
  );
  return providerSourceInfo;
};

export function findThemePageV7DefaultByType(
  themePages: IThemePage[] | undefined,
  type: TemplateType,
): IThemePage | undefined {
  return themePages?.find((page) => !!page.default && page.type === type);
}
